import React from "react";
import { Async } from "react-select";
import { graphql, compose, withApollo } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment-timezone";
import QuickDatePicker from "./QuickDatePicker";
import plus from "../../img/plus.svg";
import steto from "../../img/steto.svg";
import chat from "../../img/chat.svg";
import CreatePatientModal from "./CreatePatientModal";
import HistoryRdvModal from "./HistoryRdvModal";
import Calendar from "../../img/calendar.svg";
import PatientOption from "./PatientOption";
import PatientValue from "./PatientValue";
import DocsContextMenu from "./DocsContextMenu";

class QuickRdvTaker extends React.Component {
  constructor(props) {
    super(props);

    let patients = [];
    let selectedPatient = null;
    if (props.patientFromLocalState && props.patientFromLocalState.Patient) {
      patients = [props.patientFromLocalState.Patient];
      selectedPatient = props.patientFromLocalState.Patient;
    }
    this.state = {
      patients: patients,
      selectedPatient: selectedPatient,
      selectedView: "week",
      availableRdvTypes: [],
      selectedRdvDate:
        moment(props.getSelectedRdv.rdvSelect.selectedDate) || moment(),
      selectedTime: false,
      isCreatePatientModalOpen: false,
      isHistoryRdvModalOpen: false,
      startDate: moment(),
      showDropdown: false,
      doctors: [],
      input: "",
      noResultsText:
        "Aucun résultat, entrez au moins 3 caractères ou 6 chiffres",
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.getAllDoctors.loading
      /*  nextProps.allSlotsQuery.loading ||
      nextProps.getCustomSlots.loading ||
      nextProps.getSpecialDays.loading*/
    ) {
      return false;
    }

    return true;
  }

  getOptions = async (input, callback) => {
    let patientId = null; //eslint-disable-line
    //    this.setState({ input });
    let cachePolicy = this.props.getSelectedRdv.rdvSelect.fromCache
      ? "cache-first"
      : "network-only";

    if (
      this.state.selectedPatient === null &&
      this.props.getSelectedRdv.rdvSelect.selectedPatientId !== null
    ) {
      patientId = this.props.getSelectedRdv.rdvSelect.selectedPatientId;
    } else if (this.state.selectedPatient !== null) {
      patientId = this.state.selectedPatient.id;
    }
    if (input.length > 2) {
      let parsed = parseInt(input, 10);
      let result = null;
      if (isNaN(parsed)) {
        //we have a space, so probably a prenom
        if (input.indexOf(" ") > -1) {
          const filters = input.split(" ");
          result = await this.props.client.query({
            query: PATIENTS_SEARCH_QUERY_WITH_PRENOM,
            variables: { nom: filters[0], prenom: filters[1] },
            fetchPolicy: cachePolicy,
          });
        } else {
          result = await this.props.client.query({
            query: PATIENTS_SEARCH_QUERY,
            variables: { filter: input },
            fetchPolicy: cachePolicy,
          });
        }
      } else {
        //is a number
        if (input.length > 5) {
          result = await this.props.client.query({
            query: PATIENTS_SEARCH_QUERY_MATRICULE,
            variables: { filter: input },
            fetchPolicy: cachePolicy,
          });
        }
      }
      if (result.data.allPatients.length > 10) {
        this.setState({
          noResultsText:
            "Trop de résultats, entrez plus de caractères ou de chiffres",
        });
        callback(null, {
          options: [],
          cache: true,
          complete: true,
        });
      } else {
        this.setState({
          noResultsText:
            "Aucun résultat, entrez au moins 3 caractères ou 6 chiffres",
        });
        callback(null, {
          options: result.data.allPatients,
          cache: true,
          complete: true,
        });
      }
    } else {
      callback(null, {
        options: this.state.patients,
        cache: false,
        complete: true,
      });
    }
    /*

      callback(null, {
        options: [],
        cache: true,
        //[{ id: "one", nom: "One" }, { id: "two", nom: "Two" }],
        // CAREFUL! Only set this to true when there are no more options,
        // or more specific queries will not be sent to the server.
        complete: true
      });
      let selectedRdvTypeId = null;
      let selectedRdvTypeDuration = null;
      let selectedDoctorId = null;
      let selectedPatientId = null;
      const selectedDate = this.props.getSelectedRdv.rdvSelect.selectedDate;
      //remove await?
     this.props.updateRdvSelect({
        variables: {
          selectedPatientId,
          selectedRdvTypeId,
          selectedRdvTypeDuration,
          selectedDoctorId,
          selectedDate
        }
      });
    }*/
  };

  handleChangeDoc = (nselectedDoctor) => {
    let selectedDoctorId = null;
    if (nselectedDoctor !== null) {
      selectedDoctorId = nselectedDoctor.id;
    }
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    this.props
      .updateRdvSelect({
        variables: {
          selectedDoctorId,
          selectedRdvTypeId,
          selectedRdvTypeDuration,
        },
      })
      .then(() => {
        this.toggleDropdown();
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };
  componentWillReceiveProps(newProps) {
    if (!newProps.getAllDoctors.loading) {
      let docs = newProps.getAllDoctors.allUsers;
      if (this.state.doctors.length === 0) {
        if (newProps.doctorId !== null) {
          //user is a doc, rearrange list so he is first
          let ndocs = [];
          let docIndex = docs.findIndex((d) => d.id === newProps.doctorId);
          if (docIndex > 0) {
            ndocs.push(docs[docIndex]);
            for (let i = 0; i < docs.length; i++) {
              if (i !== docIndex) {
                ndocs.push(docs[i]);
              }
            }
            docs = ndocs;
          }
        }
        if (docs.length > 2) {
          this.setState({ activeTab: 0, doctors: docs });
        } else {
          this.setState({ activeTab: -1, doctors: docs });
        }
      }
    }

    if (
      this.props.getSelectedRdv.rdvSelect.selectedPatientId ===
      newProps.getSelectedRdv.rdvSelect.selectedPatientId
    ) {
      if (newProps.patientFromLocalState.Patient) {
        this.setState({
          patients: [newProps.patientFromLocalState.Patient],
          selectedPatient: newProps.patientFromLocalState.Patient,
        });
      }
    }
    if (
      this.props.getSelectedRdv.rdvSelect.selectedDate !==
      newProps.getSelectedRdv.rdvSelect.selectedDate
    ) {
      this.setState({
        selectedRdvDate: moment(newProps.getSelectedRdv.rdvSelect.selectedDate),
      });
    }

    /*  if (newProps.getSelectedRdv.rdvSelect.selectedPatientId === null) {
      this.setState({
        selectedRdvDate: moment(newProps.getSelectedRdv.rdvSelect.selectedDate),
        selectedPatientId: newProps.getSelectedRdv.rdvSelect.selectedPatientId,
        selectedPatient: null
      });
    } else {
      this.setState({
        selectedRdvDate: moment(newProps.getSelectedRdv.rdvSelect.selectedDate),
        selectedPatientId: newProps.getSelectedRdv.rdvSelect.selectedPatientId
      });
    }*/
  }

  filterOptions = (options, filter, currentValues) => {
    /*  if (filter.length > 0) {
      return options.filter(o => {
        let label = o.nom + " " + o.prenom + " " + o.matricule;
        label = label
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

        filter = filter
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

        return label.indexOf(filter) > -1;
      });
    } else {*/
    return options;
    //}
  };
  handleChangePatient = async (selectedPatient) => {
    //  this.setState({ selectedPatient });
    let selectedPatientId = null;
    let patients = [];
    if (selectedPatient !== null) {
      selectedPatientId = selectedPatient.id;
      patients = [selectedPatient];
    }
    let selectedRdvTypeId = null;
    let selectedRdvTypeDuration = null;
    let selectedDoctorId = this.props.getSelectedRdv.rdvSelect.selectedDoctorId;

    const selectedDate = this.props.getSelectedRdv.rdvSelect.selectedDate;

    this.props
      .updateRdvSelect({
        variables: {
          selectedPatientId,
          selectedRdvTypeId,
          selectedRdvTypeDuration,
          selectedDoctorId,
          selectedDate,
        },
      })
      .catch((e) => {
        console.error("update local state", e);
      });
    this.setState({
      selectedPatient: selectedPatient,
      patients: patients,
    });
  };

  setSelectedView = (selectedView) => {
    this.props
      .updateRdvSelect({
        variables: { selectedView },
      })
      .then(() => {
        //this.props.history.replace("/");
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };

  handleChangeDate = (date) => {
    const selectedDate = moment(date).valueOf();
    this.props
      .updateRdvSelect({
        variables: { selectedDate },
      })
      .then(() => {
        //this.props.history.replace("/");
        this.setState({
          selectedRdvDate: date,
        });
      })
      .catch((e) => {
        console.error("update local state", e);
      });
  };

  toggleHistoryModal = (historyPatientId) => {
    this.setState({
      isHistoryRdvModalOpen: !this.state.isHistoryRdvModalOpen,
      historyPatientId: historyPatientId,
    });
  };
  toggleCreatePatientModal = () => {
    this.setState({
      isCreatePatientModalOpen: !this.state.isCreatePatientModalOpen,
    });
  };

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
    });
  };
  handleBackArrowDate = () => {
    let selectedView = "week";
    if (this.props.getSelectedRdv.rdvSelect) {
      selectedView = this.props.getSelectedRdv.rdvSelect.selectedView;
    }
    if (selectedView === "week") {
      let currentDate = moment(this.state.selectedRdvDate).subtract(1, "weeks");
      currentDate = moment(currentDate).startOf("week");
      this.handleChangeDate(currentDate);
    }
    if (selectedView === "day") {
      let currentDate = moment(this.state.selectedRdvDate).subtract(1, "day");
      this.handleChangeDate(currentDate);
    }
  };
  handleForwardArrowDate = () => {
    let selectedView = "week";
    if (this.props.getSelectedRdv.rdvSelect) {
      selectedView = this.props.getSelectedRdv.rdvSelect.selectedView;
    }
    if (selectedView === "week") {
      let currentDate = moment(this.state.selectedRdvDate).add(1, "weeks");
      currentDate = moment(currentDate).startOf("week");
      this.handleChangeDate(currentDate);
    }
    if (selectedView === "day") {
      let currentDate = moment(this.state.selectedRdvDate).add(1, "day");
      this.handleChangeDate(currentDate);
    }
  };
  renderActiveDocName = () => {
    let doc = null;
    if (this.state.doctors.length > 0) {
      doc = this.state.doctors.find(
        (doc) => doc.id === this.props.getSelectedRdv.rdvSelect.selectedDoctorId
      );
      if (doc) {
        return doc.name;
      }
    }
    return null;
  };

  render() {
    const { selectedPatient } = this.state;

    let selectedPatientValue = selectedPatient
      ? this.state.selectedPatient.id
      : null;
    let selectedView = "week";
    if (this.props.getSelectedRdv.rdvSelect) {
      selectedView = this.props.getSelectedRdv.rdvSelect.selectedView;
    }
    return (
      <nav className="navbar is-fixed-top">
        <div className="navbar-menu">
          <div className="container">
            <div className="columns quick is-centered">
              <div className="column is-narrow is-hidden-touch" />
              {this.props.history.location.pathname !== "/" ? (
                <div className="column is-narrow ">
                  <figure className="image is-30x30">
                    <a href="/">
                      <img alt="Calendar" src={Calendar} />
                    </a>
                  </figure>
                </div>
              ) : null}
              <div className="column" style={{ position: "relative" }}>
                <Async
                  autoBlur={true}
                  loadOptions={
                    this.getOptions
                  } /*{async (input, callback) => {
                    await this.getOptions(
                      input,
                      callback,
                      selectedPatientValue
                    );
                  }}*/
                  autoload={true}
                  onBlurResetsInput={false}
                  onCloseResetsInput={false}
                  searchPromptText="Entrez au moins 3 caractères ou 6 chiffres"
                  noResultsText={this.state.noResultsText} //"Aucun résultat, entrez au moins 3 caractères ou chiffres"
                  loadingPlaceholder="Chargement..."
                  cache={false}
                  onSelectResetsInput={true}
                  //deleteRemoves={false}
                  //  backspaceRemoves={false}
                  name="form-field-name"
                  placeholder="Cherchez un patient"
                  value={selectedPatientValue}
                  options={this.state.patients}
                  labelKey="nom"
                  openOnClick={false}
                  valueKey="id"
                  matchProp="any"
                  clearable={true}
                  menuContainerStyle={{
                    width: "calc(100% - 35px)",
                  }}
                  onChange={(v) => this.handleChangePatient(v)}
                  optionComponent={({
                    toggleHistoryModal,
                    toggleChatModal,
                    ...props
                  }) => {
                    return (
                      <PatientOption
                        toggleChatModal={this.props.toggleChatModal}
                        openHistoryModal={this.props.openHistoryModal}
                        {...props}
                      />
                    );
                  }}
                  valueComponent={PatientValue}
                  filterOptions={this.filterOptions}
                  style={{
                    width: "calc(100% - 35px)",
                  }}
                />
                <figure
                  className="image is-30x30"
                  style={{
                    position: "absolute",
                    top: "24px",
                    right: 0,
                    cursor: "pointer",
                  }}
                >
                  <img
                    onClick={this.toggleCreatePatientModal}
                    alt="plus"
                    src={plus}
                  />
                </figure>
              </div>

              <div className="column is-6-desktop has-text-right is-7-tablet   is-12-mobile">
                <button
                  className="button"
                  onClick={() => this.handleChangeDate(moment())}
                >
                  Aujourd'hui
                </button>
                <button className="button" onClick={this.handleBackArrowDate}>
                  {"<"}
                </button>
                <button
                  className="button"
                  onClick={this.handleForwardArrowDate}
                >
                  {">"}
                </button>

                <QuickDatePicker
                  selectedRdvDate={this.state.selectedRdvDate}
                  onChange={this.handleChangeDate}
                  minDate={this.state.startDate}
                  //  excludeTimes={this.state.timesToExclude}
                  slots={this.props.slots}
                  //    doctorId={this.state.selectedDoctorId || this.props.doctorId}
                  //options={this.props.options}
                />

                <button
                  onClick={() => this.setSelectedView("day")}
                  className={`button
                    ${selectedView === "day" ? " is-primary" : ""}`}
                >
                  jour
                </button>
                <button
                  onClick={() => this.setSelectedView("week")}
                  className={`button
                    ${selectedView === "week" ? " is-primary" : ""}`}
                >
                  semaine
                </button>
              </div>

              <div className="column is-narrow">
                {!this.props.getAllUsers.loading && (
                  <div
                    className={`dropdown is-right is-pulled-right ${
                      this.state.showDropdown ? " is-active" : ""
                    }`}
                  >
                    <div className="dropdown-trigger">
                      <figure className="image is-32x32">
                        <a onClick={this.toggleDropdown}>
                          <img alt="Doctors" src={steto} />
                        </a>
                      </figure>
                    </div>

                    <DocsContextMenu
                      toggleDropdown={this.toggleDropdown}
                      doctors={this.state.doctors}
                      selectedDoctorId={
                        this.props.getSelectedRdv.rdvSelect.selectedDoctorId
                      }
                      handleChangeDoc={this.handleChangeDoc}
                    />
                  </div>
                )}
                <div
                  className="is-right is-pulled-right"
                  style={{ marginRight: "0.5rem" }}
                >
                  <figure className="image is-32x32">
                    <a onClick={() => this.props.toggleChatModal()}>
                      <img alt="Doctors" src={chat} />
                    </a>
                  </figure>
                </div>
              </div>

              {this.state.isCreatePatientModalOpen ? (
                <CreatePatientModal
                  toggleModal={this.toggleCreatePatientModal}
                  handleChangePatient={this.handleChangePatient}
                />
              ) : (
                ""
              )}
              {this.props.isHistoryModalOpen ? (
                <HistoryRdvModal
                  toggleChatModal={this.props.toggleChatModal}
                  closeHistoryModal={this.props.closeHistoryModal}
                  handleChangePatient={this.handleChangePatient}
                  patientId={this.props.idPatientToShow}
                />
              ) : null}
            </div>
          </div>
        </div>
        <p
          className="menu-label"
          style={{
            position: "absolute",
            marginLeft: 15,
            top: "50px",
          }}
        >
          {this.renderActiveDocName()}
        </p>
      </nav>
    );
  }
}

/*const ALL_PATIENTS_QUERY = gql`
  query AllPatientsQuery($skipNum: Int!) {
    allPatients(orderBy: nom_ASC, first: 1000, skip: $skipNum) {
      id
      nom
      prenom
      matricule
    }
  }
`;*/
const PATIENTS_SEARCH_BY_ID = gql`
  query getPatientById($id: ID!) {
    Patient(id: $id) {
      id
      nom
      prenom
      matricule
    }
  }
`;

const PATIENTS_SEARCH_QUERY = gql`
  query AllPatientsQuery($filter: String!) {
    allPatients(
      orderBy: nom_ASC
      filter: { OR: [{ nom_starts_with: $filter }] }
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;
const PATIENTS_SEARCH_QUERY_WITH_PRENOM = gql`
  query AllPatientsQueryPrenom($nom: String!, $prenom: String!) {
    allPatients(
      orderBy: nom_ASC
      filter: {
        AND: [{ nom_starts_with: $nom }, { prenom_starts_with: $prenom }]
      }
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;
const PATIENTS_SEARCH_QUERY_MATRICULE = gql`
  query AllPatientsQueryMatricule($filter: String!) {
    allPatients(
      orderBy: nom_ASC
      filter: { OR: [{ matricule_starts_with: $filter }] }
    ) {
      id
      nom
      prenom
      matricule
    }
  }
`;

const UPDATE_RDV_SELECT = gql`
  mutation updateRDVSelect(
    $selectedDate: Int
    $selectedPatientId: String
    $selectedDoctorId: String
    $selectedRdvTypeId: String
    $selectedRdvTypeDuration: Int
    $selectedView: String
  ) {
    updateRDVSelect(
      selectedRdvTypeId: $selectedRdvTypeId
      selectedRdvTypeDuration: $selectedRdvTypeDuration
      selectedDoctorId: $selectedDoctorId
      selectedDate: $selectedDate
      selectedPatientId: $selectedPatientId
      selectedView: $selectedView
    ) @client
  }
`;
const GET_SELECTED_RDV = gql`
  query {
    rdvSelect @client {
      selectedDate
      selectedPatientId
      selectedView
      selectedDoctorId
      fromCache
    }
  }
`;

const GET_ALL_DOCTORS_QUERY = gql`
  query {
    allUsers(filter: { role: DOCTOR }) {
      id
      name
    }
  }
`;
const GET_ALL_USERS_QUERY = gql`
  query {
    allUsers {
      id
      name
    }
  }
`;

export default compose(
  /*graphql(ALL_PATIENTS_QUERY, {
    name: "getAllPatientsQuery",
    options: { variables: { skipNum: 0 } }
  }),*/
  graphql(GET_ALL_DOCTORS_QUERY, {
    name: "getAllDoctors",
  }),
  graphql(GET_ALL_USERS_QUERY, {
    name: "getAllUsers",
  }),
  graphql(UPDATE_RDV_SELECT, {
    name: "updateRdvSelect",
    //  options: ({ doctorId }) => ({ variables: { doctorId } })
  }),
  graphql(GET_SELECTED_RDV, {
    name: "getSelectedRdv",
    options: { fetchPolicy: "cache-only" },
  }),
  graphql(PATIENTS_SEARCH_BY_ID, {
    name: "patientFromLocalState",
    skip: ({ getSelectedRdv }) =>
      getSelectedRdv.rdvSelect === null ||
      getSelectedRdv.rdvSelect === undefined,
    options: (props) => {
      return {
        variables: { id: props.getSelectedRdv.rdvSelect.selectedPatientId },
      };
    },
  }),
  withApollo
  /*  graphql(GET_ALL_DOCTORS_QUERY, {
    name: "getAllDoctors",
    skip: ({ role }) => role !== "SECRETARY"
  })*/
)(QuickRdvTaker);



// WEBPACK FOOTER //
// ./src/components/utilities/QuickRdvTaker.js